export enum OrientationEnum {
  landscape = 1,
  portrait = 2
}
